import React from 'react';
import { Users, Plus, Upload } from 'lucide-react';
import CardBasic from '../ui/Card.jsx';
import ContactsTabs from './list/ContactsTabs.jsx';

const ContactsIndex = () => {
    const renderHeaderActions = (tabId) => {
        const btnSecondaryClass = "btn btn-xs btn-outline-secondary d-flex align-items-center gap-2";

        switch (tabId) {
            case 'contacts':
                return (
                    <div className="d-flex gap-2">
                        <a href="index.php/contacts/importContacts" className={btnSecondaryClass}>
                            <Upload size={18} />
                            Kontakte importieren
                        </a>
                        <a href="index.php/contacts/exportAll" className={btnSecondaryClass}>
                            <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                            </svg>
                            Export aller Kontakte
                        </a>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div>
            <div className="mb-4">
                <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-3">
                    <div>
                        <h1 className="h2 fw-bold text-dark d-flex align-items-center gap-2 mb-2">
                            <Users size={32} className="icon-contacts" />
                            Kontakte
                        </h1>
                        <p className="text-muted mb-0">
                            Verwalten Sie Ihre Kunden und Geschäftskontakte
                        </p>
                    </div>
                    <a
                        href="index.php/contacts/new"
                        className="btn btn-outline-primary d-flex align-items-center gap-2 shadow"
                    >
                        <Plus size={20} />
                        Neuer Kontakt
                    </a>
                </div>
            </div>
            <CardBasic>
                <ContactsTabs headerActions={renderHeaderActions} />
            </CardBasic>
        </div>
    );
}

export default ContactsIndex;
